import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ObjectId from 'bson-objectid';
import { Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

// Services
import { getEquipmentById, getEquipmentByRefId, getEquipmentTrace } from '../../../services/equipment.service';

// Types
import { Equipment } from '../../../types/Equipment';
import { TraceInfo } from '../../../types/TraceInfo';

// Components
import Pairing from '../device/Pairing';
import EquipmentImage from './equipmentImages';
import EquipmentTraceStage from './EquipmentTraceStage';
import { usePageTitle } from '../../../hooks/usePageTitle';
import { OverviewCard } from '../../common/OverviewCard/OverviewCard';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  marginBottom: 2,
  color: theme.palette.text.secondary,
}));

export default function EquipmentDetails() {
  const { id } = useParams<{ id: string }>();
  const [equipment, setEquipment] = useState<Equipment | null>(null);
  const [traceInfo, setTraceInfo] = useState<TraceInfo | null>(null);

  usePageTitle(equipment?.serialNumber, { replaceId: true });

  useEffect(() => {
    const fetchEquipment = async () => {
      if (id) {
        try {
          let equipmentRes: any;
          if (ObjectId.isValid(id)) {
            equipmentRes = await getEquipmentByRefId(id);
          } else {
            equipmentRes = await getEquipmentById(id);
          }
          if (equipmentRes?.data?.results && equipmentRes.data.results.length > 0) {
            setEquipment(equipmentRes.data.results[0]);
          } else if (equipmentRes?.data) {
            setEquipment(equipmentRes.data);
          }
        } catch (error) {
          console.error('Error fetching equipment:', error);
        }
      }
    };

    const fetchTraceInfo = async () => {
      if (id) {
        try {
          const traceRes = await getEquipmentTrace(id);
          setTraceInfo(traceRes);
        } catch (error) {
          console.error('Error fetching trace info:', error);
        }
      }
    };

    fetchEquipment();
    fetchTraceInfo();
  }, [id]);

  return (
    <>
      {traceInfo && <EquipmentTraceStage traceInfo={traceInfo} />}
      {!traceInfo && <div>Trace Info Loading...</div>}
      {equipment && (
        <Item style={{ marginTop: 5 }}>
          <OverviewCard title='Equipment Images'>
            <EquipmentImage equipment={equipment} />
          </OverviewCard>
        </Item>
      )}
      <Item style={{ marginTop: 5 }}>
        <OverviewCard title='Current Pairing'>
          <Pairing equipmentId={id} noHistoryCardRadius />
        </OverviewCard>
      </Item>
    </>
  );
}
